function decodeHtmlEntities(value: string): string {
  if (typeof document === 'undefined') {
    return value
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

const COPYRIGHT_LINE = /©\s*\d{4}/;

/**
 * The template's default body text, shown as the placeholder when an admin
 * edits the body override. Branded emails mark it with data-lw-slot="body";
 * older templates fall back to the first substantial paragraph that is not
 * the footer.
 */
export function previewBodyText(html: string | null | undefined): string | null {
  if (!html) {
    return null;
  }
  let text = '';
  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('script, style').forEach((node) => node.remove());
    const slot = doc.querySelector('[data-lw-slot="body"]');
    if (slot) {
      text = slot.textContent?.replace(/\s+/g, ' ').trim() ?? '';
    }
    if (!text) {
      const blocks = Array.from(doc.querySelectorAll('p, div'))
        .map((node) => node.textContent?.replace(/\s+/g, ' ').trim() ?? '')
        .filter((entry) => entry.length >= 40 && !COPYRIGHT_LINE.test(entry));
      text = blocks[0] ?? '';
    }
  }
  if (!text) {
    text = decodeHtmlEntities(html.replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<style[\s\S]*?<\/style>/gi, '').replace(/<[^>]+>/g, ' '));
  }
  return text.replace(/\s+/g, ' ').trim().slice(0, 500) || null;
}
